import {
  isMorning,
  isAfternoon,
  isEvening
} from '../../../../../features/rmc/shared/order-editor/components/fields/Time/timeUtils'
import {Slot} from '../types'

// Group time slots by time of day categories
export const groupSlotsByTimeOfTheDay = (data: Slot[]) => {
  const morningSlots: Slot[] = []
  const afternoonSlots: Slot[] = []
  const eveningSlots: Slot[] = []

  data.forEach((item) => {
    if (isMorning(item.slotConfig.slotStart)) {
      morningSlots.push(item)
    } else if (isAfternoon(item.slotConfig.slotStart)) {
      afternoonSlots.push(item)
    } else if (isEvening(item.slotConfig.slotStart)) {
      eveningSlots.push(item)
    }
  })

  return {morningSlots, afternoonSlots, eveningSlots}
}
